<div class="one" [formGroup]="SettingForm" fxLayout="column">
  <div fxLayout="row wrap" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      class="a"
      appearance="outline"
      class="name-input pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.PRACACCACCOUNTNAME),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PRACACCACCOUNTNAME),
      }"
    >
      <mat-label>Account Name</mat-label>
      <input name="PRACACCACCOUNTNAME" formControlName="PRACACCACCOUNTNAME" matInput />
      <mat-icon matSuffix class="secondary-text"></mat-icon>
    </mat-form-field>
    <mat-form-field
      class="a"
      appearance="outline"
      class="name-input pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.PRACACCBSB),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PRACACCBSB),
      }"
    >
      <mat-label>BSB</mat-label>
      <input name="PRACACCBSB" formControlName="PRACACCBSB" matInput />
      <mat-icon matSuffix class="secondary-text"></mat-icon>
    </mat-form-field>
    <mat-form-field
      class="a"
      appearance="outline"
      class="name-input pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.PRACACCACCOUNTNUMBER),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PRACACCACCOUNTNUMBER),
      }"
    >
      <mat-label>A/C No</mat-label>
      <input name="PRACACCACCOUNTNUMBER" formControlName="PRACACCACCOUNTNUMBER" matInput />
      <mat-icon matSuffix class="secondary-text"></mat-icon>
    </mat-form-field>
  </div>

  <div class="mt-4" fxLayout="row wrap" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      class="a"
      appearance="outline"
      class="name-input pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.SWIFTID),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.SWIFTID),
      }"
    >
      <mat-label>Swift ID</mat-label>
      <input name="SWIFTID" formControlName="SWIFTID" matInput />
      <mat-icon matSuffix class="secondary-text"></mat-icon>
    </mat-form-field>
  </div>
  <div class="pt-4">
    <mat-dialog-actions class="popup_ftr justify-end!">
      <button
        class="mainbtn_size"
        matButton="filled"
        [disabled]="isspiner"
        (click)="savePracticeAccount()"
      >
        @if (isspiner) {
          <mat-spinner diameter="24"></mat-spinner>
        }
        Save
      </button>
      <!-- <button class="btn_2" mat-raised-button color="primary" cdkFocusInitial>Don't Save</button> -->
    </mat-dialog-actions>
  </div>
</div>
